<template>
    <span>
        <a href="#" @click="showme">{{username}}</a>

        <el-dialog v-if="isshowme" :visible.sync="isshowme" top="0px" class="mydialog2 modulewrap" append-to-body>
            <div class="mempopwrap" @click="shownavmain=false">
                <div class="mempopnav">
                    <div class="navline"></div>
                    <template v-if="!$store.getters.issmall">

                        <dl v-if="$common.basic.isarrayexist(memnav)">
                            <dd v-for="item in this.memnav" :key="item.id"><a href="#" :class="{cs:curnav==item.kv}" @click="showsub(item.kv)">{{$common.langinfo(item.title,item.title_en)}}</a></dd>
                        </dl>
                    </template>
                    <template v-else>
                        <div class="memnavbox">
                            <a href="#" @click.stop.prevent="shownavmain=!shownavmain">{{$common.langinfo(c_navmain.title,c_navmain.title_en)}}</a>
                            <transition name="slidedown">
                                <div class="memmainnavmore" v-show="shownavmain">
                                    <dl v-if="$common.basic.isarrayexist(memnav)">
                                        <dd v-for="item in this.memnav" :key="item.id"><a href="#" :class="{cs:curnav==item.kv}" @click="showsub(item.kv)">{{$common.langinfo(item.title,item.title_en)}}</a></dd>
                                    </dl>
                                </div>
                            </transition>

                        </div>

                    </template>
                </div>
                <div class="mempopbodywrap">
                    <div class="memsearch" v-if="$common.basic.isarrayexist(c_listlevel)">
                        <div class="left">
                            <el-cascader ref="caslevel" v-model="caslevelvalue" v-if="$common.basic.isarrayexist(c_listlevel)" :options="c_listlevel" size="mini" class="memselect" popper-class="calevel"
                                         :props="casoption" :show-all-levels="false"
                                         :clearable="curnav!=3" :placeholder="$common.dicword('allcourse')" @change="optionchange"></el-cascader>
                        </div>
                        <div class="right"></div>
                    </div>

                    <div class="mempopbody">
                        <myScroll class="scroll">
                            <div v-if="curnav==0" class="profile">
                                <div class="face">
                                    <div class="faceimg"><img :src="$common.getface(me.face)" /></div>
                                </div>
                                <div class="info">
                                    <div class="view">
                                        <dl><dt>{{$common.dicword('username',true)}}</dt><dd>{{me.username}}</dd></dl>
                                        <dl><dt>{{$common.dicword('mobile',true)}}</dt><dd>{{me.mobile}}</dd></dl>
                                        <dl v-if="me.companyid>0"><dt>{{$common.dicword('school',true)}}</dt><dd>{{$common.langinfo(infoschool.title,infoschool.title_en)}}</dd></dl>
                                        <dl v-if="me.groupid>0"><dt>{{$common.dicword('infoclass',true)}}</dt><dd>{{$common.langinfo(infogroup.title,infogroup.title_en)}}</dd></dl>
                                        <dl><dt>{{$common.dicword('realname',true)}}</dt><dd>{{me.realname}}</dd></dl>
                                        <dl><dt>{{$common.dicword('nickname',true)}}</dt><dd>{{me.showname}}</dd></dl>
                                        <dl><dt>{{$common.dicword('birth',true)}}</dt><dd>{{$common.basic.dateformat( me.birth)}}</dd></dl>
                                        <dl><dt>{{$common.dicword('gender',true)}}</dt><dd>{{$common.chgender(me.sex)}}</dd></dl>
                                        <dl><dt>{{$common.dicword('address',true)}}</dt><dd>{{me.addr}}</dd></dl>
                                    </div>
                                </div>
                            </div>


                            <Cschedule v-if="curnav==2" :navsub="1" :options="c_myoption" :stuid="stuid"></Cschedule>
                            <Clecture v-if="curnav==1" :navsub="1" :options="c_myoption" :stuid="stuid"></Clecture>
                            <Cwork v-if="curnav==3" :navsub="1" :options="c_myoption" :stuid="stuid"></Cwork>
                            <Cprogress v-if="curnav==4" :options="c_myoption" :stuid="stuid"></Cprogress>
                            <Clearn v-if="curnav==5" :navsub="1" :options="c_myoption" :stuid="stuid"></Clearn>
                        </myScroll>
                    </div>
                </div>

            </div>
        </el-dialog>
    </span>

</template>


<script>
    export default {
        name: 'ffmember',
        data() {
            return {
                memnav: [],
                curnav: 0,
                me: {},
                infoschool: {},
                infogroup: {},
                isload: false,
                isshowme: false,
                myoption: {
                    levelid: -1,
                    courseid: -1,
                    topicid: -1
                },
                caslevelvalue: '',
                shownavmain: false,
                listlevel: []
            };
        },
        components: {
            Cschedule: () => import('@/components/Cschedule'),
            Cwork: () => import('@/components/Cwork'),
            Clecture: () => import('@/components/Clecture'),
            Cprogress: () => import('@/components/Cprogress'),
            Clearn: () => import('@/components/Clearn'),
        },
        props: {
            username: {
                type: String,
                default: ''
            },
            stuid: {
                type: Number,
                default: 0
            }
        },
        computed: {
            c_navmain: function () {
                return this.$common.basic.fffind(this.memnav, 'kv', this.curnav);
            },
            c_listlevel: function () {
                let _listlevel = this.$common.basic.jsonclone(this.listlevel);
                switch (this.curnav) {
                    case 0:
                        _listlevel = [];
                        break;
                    case 1:
                    case 2:
                    case 3:
                        _listlevel = this.$common.basic.fffilter(_listlevel, 'isdemand', 0);
                        this.$common.each(_listlevel, item => {
                            this.$common.each(item.x_children, item2 => {
                                item2.x_children = null;
                            })
                        })
                        break;
                    case 4:
                        _listlevel = this.$common.basic.jsonclone(_listlevel);
                        this.$common.each(_listlevel, item => {
                            this.$common.each(item.x_children, item2 => {
                                item2.x_children = null;
                            })
                        })
                        break;
                }
                return _listlevel;
            },
            c_myoption: function () {
                let _myoption = this.$common.basic.jsonclone(this.myoption);
                _myoption.tk = 1;
                return _myoption;
            },
            casoption: function () {
                return this.curnav == 3 ? { expandTrigger: 'hover', value: 'id', label: 'title', children: 'x_children' } : { checkStrictly: true, expandTrigger: 'hover', value: 'id', label: 'title', children: 'x_children' };
            }
        },
        methods: {
            showme: function () {
                let jsondata = { 'postdata': { 'act': 'tea_t_membernav', "id": this.stuid } };
                this.$common.post(jsondata, res => {
                    if (res.infodata) {
                        this.memnav = res.infodata;
                        this.me = res.infodatame;
                        this.infoschool = res.infodataschool;
                        this.infogroup = res.infodatagroup;

                        this.isshowme = true;
                        if (res.infodata.length > 1) {
                            this.getoptions(0);
                        }

                    }

                });

            },
            optionchange: function (e) {
                this.$refs.caslevel.dropDownVisible = false;
                if (this.$common.basic.isarrayexist(e)) {
                    this.myoption.levelid = e[0];
                    this.myoption.courseid = e.length > 1 ? e[1] : -1;
                    this.myoption.topicid = e.length > 2 ? e[2] : -1;
                }
                else {
                    this.myoption.levelid = -1;
                    this.myoption.courseid = -1;
                    this.myoption.topicid = -1;
                }
                this.getdata();
            },
            getoptions: function () {
                let jsondata = {
                    'postdata': { 'act': 'tea_my_topic', 'data': { 'hasdemand': 1, 'hastopic': 1, 'stuid': this.stuid } }, 'msg': ''
                };
                this.$common.post(jsondata, res => {
                    this.$common.each(res.infodatacourse, item => {
                        item.x_children = this.$common.basic.fffilter(res.infodatatopic, "courseid", item.id);
                    });
                    this.$common.each(res.infodatalevel, item => {
                        item.x_children = this.$common.basic.fffilter(res.infodatacourse, "levelid", item.id);

                    });

                    this.listlevel = res.infodatalevel || [];

                });
            },
            showsub: function (v) {
                if (v == 3) {
                    if (this.myoption.courseid <= 0) {
                        let firstlevelid = this.$common.basic.isarrayexist(this.listlevel) ? this.listlevel[0].id || 0 : 0;
                        let firstcourse = firstlevelid ? this.$common.basic.isarrayexist(this.listlevel[0].x_children) ? this.listlevel[0].x_children[0] || {} : {} : {};
                        this.caslevelvalue = [firstlevelid, firstcourse.id || 0];
                        this.myoption.levelid = firstlevelid;
                        this.myoption.courseid = firstcourse.id || 0;
                    }

                }
                this.curnav = v;
            },
            getdata: function () {
                let cnav = this.curnav;
                this.curnav = -1;
                this.$nextTick(() => {
                    this.curnav = cnav;
                });
            }

        }
    }
</script>
